import { Injectable } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { ENDPOINTS } from '../shared/constants/url.constants';
import { GlobalErrorHandlerService } from '../shared/services/global-error-handler.service';
import { HttpRequestService } from '../shared/services/http-request.service';
import { formatUrl } from '../shared/utils/format-url-util';
import { NotificationService } from '../shared/services/notification.service';

@Injectable()
export class ProviderServiceCredentialsService {
  constructor(
    private httpClient: HttpRequestService,
    private errorHandler: GlobalErrorHandlerService,
    private notificationService: NotificationService
  ) { }

  getAssociationServiceCodes(programCode: any, associationIds: number[]): Observable<any> {
    const url = formatUrl(ENDPOINTS.SERVICE_CREDENTIALS.POST_SERVICE_CODES, {
      programCode
    });

    return this.httpClient.post(url, { associationIds }).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  getProviderServiceCredentials(programCode: any, providerId: any): Observable<any> {
    const url = formatUrl(ENDPOINTS.SERVICE_CREDENTIALS.GET_SERVICE_CREDENTIALS, {
      programCode, providerId
    });

    return this.httpClient.get(url).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  saveServiceCredentials(programCode: any, formData: any): Observable<any> {
    const url = formatUrl(ENDPOINTS.SERVICE_CREDENTIALS.POST_SERVICE_CREDENTIALS, { programCode });
    return this.httpClient.post(url, formData).pipe(
      tap(() => {
        this.notificationService.success(
          'Success',
          'Credential information saved successfully'
        );
      }),
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }
}
